import React from 'react'
import Spinner from '../../../components/Spinner/Spinner'
import Icons from '../../../components/Icons'
import {formatTime} from '../../../utils/time'
import {getDayParts} from '../../../utils/recurrence'
import Header from '../../../components/Header/Header'
import {
  Container,
  ButtonContainer,
  ErrorContainer,
  FieldContainer,
  Name,
  SubText,
  ContactInfoText,
  UserLocation,
  TimeContainer,
  TimeIcon,
  TimeTitle,
  TimeTitleText,
  User,
  UserName,
  Content,
  StyledFormButton,
  EditContainer
} from '../../../components/kiosk/KioskContent/WorkspacesSequence/Summary/StyledSummary'
import Clock from '../../../components/Clock/Clock'
import HeaderButton from '../../../components/Header/HeaderButton'
import {_L, useLocaleState} from '../../../context/LocaleContext'
import ErrorMessage from '../../../components/ErrorContainer'

const WorkspacesEdit = ({reservation, onCancelReservation, onCancel}) => {
  const localeState = useLocaleState()

  const {
    emId,
    visitorsNameFirst,
    visitorsNameLast,
    flId,
    rmId,
    description,
    dateStart,
    dayPart,
    dpId
  } = reservation

  let employeeName =
    visitorsNameFirst && visitorsNameLast
      ? `${visitorsNameFirst} ${visitorsNameLast}`
      : emId

  let error = null
  let loading = false

  const cancelReservation = () => onCancelReservation(reservation)

  return (
    <Content>
      <Header
        leftContent={<Clock />}
        rightContent={
          <HeaderButton
            label={_L({key: 'Cancel', localeState})}
            onClick={onCancel}
          />
        }
      />
      <EditContainer>
        <Container>
          <FieldContainer>
            <SubText>{_L({key: 'Booking for', localeState})}</SubText>
            <User>
              <UserName>
                <Name>{employeeName}</Name>
              </UserName>
            </User>

            <UserLocation>
              <ContactInfoText>
                {dpId} {_L({key: 'Floor', localeState})} {flId}
              </ContactInfoText>
            </UserLocation>

            <UserLocation>
              <ContactInfoText>
                {rmId} {description}
              </ContactInfoText>
            </UserLocation>

            <TimeContainer>
              <TimeTitle>
                <TimeTitleText>
                  {formatTime(dateStart, 'MMM D, YYYY')}
                </TimeTitleText>
              </TimeTitle>

              <TimeIcon>
                <Icons icon="CALENDAR" />
              </TimeIcon>
            </TimeContainer>

            <TimeContainer>
              <TimeTitle>
                <TimeTitleText>
                  {getDayParts({localeState})[dayPart]}
                </TimeTitleText>
              </TimeTitle>
              <TimeIcon>
                <Icons icon="CLOCK" />
              </TimeIcon>
            </TimeContainer>

            {error && (
              <ErrorContainer>
                <ErrorMessage errorMessage={error} />
              </ErrorContainer>
            )}
          </FieldContainer>

          <ButtonContainer>
            <StyledFormButton onClick={cancelReservation}>
              {loading ? <Spinner /> : _L({key: 'CANCEL BOOKING', localeState})}
            </StyledFormButton>
          </ButtonContainer>
        </Container>
      </EditContainer>
    </Content>
  )
}

export default WorkspacesEdit
